"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

var _default = isMobile;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJpc01vYmlsZSIsIndpbmRvdyIsIm1hdGNoTWVkaWEiLCJtYXRjaGVzIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2lzTW9iaWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IGlzTW9iaWxlID0gKCkgPT4gd2luZG93Lm1hdGNoTWVkaWEoJyhtYXgtd2lkdGg6IDc2OHB4KScpLm1hdGNoZXNcblxuZXhwb3J0IGRlZmF1bHQgaXNNb2JpbGVcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLE1BQU1BLFFBQVEsR0FBRyxNQUFNQyxNQUFNLENBQUNDLFVBQVAsQ0FBa0Isb0JBQWxCLEVBQXdDQyxPQUEvRDs7ZUFFZUgsUSJ9